export const COLO_COOKIE_BANNER_SEEN = 'coloCookieBannerSeen';

export const COOKIE_BANNER_TEST_ID = {
  root: 'cookie-banner',
  link: 'cookie-banner-link',
  button: 'cookie-banner-dismiss-button'
};
